import { ThemeService } from '@app/theme/theme.service';
import { defaultTheme } from '@app/theme/theme';
import { EnvironmentProviders, inject, provideAppInitializer } from '@angular/core';
import { firstValueFrom } from 'rxjs';

export const ColorInitializerProvider: EnvironmentProviders = provideAppInitializer(async () => {
  const themeService = inject(ThemeService);

  try {
    const themeCookie = themeService.getTheme();
    if (themeCookie.theme && themeCookie.theme.trim() !== '') {
      themeService.setColorsValues(themeCookie);
      return;
    }
    
    // Block SSR rendering until theme is fetched from API
    await firstValueFrom(themeService.fetchTheme());
  } catch (error) {
    console.warn('Using default theme during SSR initialization:', error instanceof Error ? error.message : error);
    themeService.setColorsValues(defaultTheme);
  }
});
